@if (blipChatService.isTooltipVisible()) {
  <div class="hints" [class.hints--expanded]="showDateHint()">
    <aside
      class="hint"
      aria-label="Fale com o suporte"
    >
      <span class="message">Está com dúvidas ou erro?</span>

      <button type="button" class="action" (click)="openSupport()">
        Fale com o suporte
      </button>

      <button
        type="button"
        class="close"
        aria-label="Fechar aviso de suporte"
        (click)="dismiss($event)"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </aside>

    <aside
      class="hint-date"
      aria-label="Atendimento de segunda a sábado, das 09h às 18h"
      [attr.aria-hidden]="!showDateHint()"
    >
      <span class="message">De segunda a sábado, das 09h às 18h</span>
    </aside>
  </div>
}
